export * from "/codebuild/output/src2688209787/src/git-codecommit.eu-west-2.amazonaws.com/v1/repos/vl-app/vl-common/wrapped-antd/index.ts"